'use strict';

var _ = require('lodash');
var MarketDropdownValuesService = function MarketDropdownValuesService($log, hepService, dropdownValuesService, configurationService) {
  /**
   * Flattened HEP list
   * @type {Array}
   */
  var values = [];

  /**
   * Transform HEP list data to flat array of objects
   *
   * @param {Object} data
   */
  function transformData(data) {
    var localOrSignificantMarkets = configurationService.getNonCodeShareMarkets();
    _.transform(data.hepList, function (result, item) {
      if (_.keys(item.attributes).length === 2 && dropdownValuesService.isLocalOrSignificantMarket(localOrSignificantMarkets, item.attributes)) {
        result.push({
          marketEntity: item.properties.entityName,
          market: item.attributes.origin + '-' + item.attributes.destination
        });
      }
      return result;
    }, values);
  }

  /**
   * Returns array of dropdown values
   *
   * @param {string} column
   * @param {Object} row
   * @returns {string[]}
   */
  function getDropdownValues(column, row) {
    return dropdownValuesService.getValues(values, column, row);
  }
  function getProductGroupDropdownValues(row) {
    return configurationService.getClassGroupsByMarket(row.market);
  }
  function updateData() {
    values = [];
    hepService.getHepByType('MarketEntity').then(transformData);
  }
  return {
    getDropdownValues: getDropdownValues,
    getProductGroupDropdownValues: getProductGroupDropdownValues,
    updateData: updateData
  };
};
MarketDropdownValuesService.$inject = ['$log', 'HepService', 'DropdownValuesService', 'ConfigurationService'];
module.exports = MarketDropdownValuesService;